import { useTranslate } from "@similarweb/i18n-provider";

import { MetricWidgetChart } from "../../common/widget/donut-metric/MetricWidgetChart";
import { MetricWidgetContainer } from "../../common/widget/donut-metric/MetricWidgetContainer";
import { MetricWidgetModal } from "../../common/widget/donut-metric/MetricWidgetModal";
import { MetricWidgetProvider } from "../../common/widget/donut-metric/MetricWidgetProvider";

import { ShareMetricLegend } from "./shared/ShareMetricLegend";
import { ShareMetricTable } from "./shared/ShareMetricTable";
import { useShareMetricQuery } from "./shared/useShareMetricQuery";

export const ShareOfPosts = () => {
    const { translate } = useTranslate();
    const {
        data: chartData,
        isLoading,
        isFetching,
        isError,
    } = useShareMetricQuery("activationAlertsMetricsSocialMediaShareOfPostsDetail");

    return (
        <MetricWidgetProvider
            chartData={chartData}
            isLoading={isLoading || isFetching}
            isError={isError}
        >
            <MetricWidgetContainer
                title={translate("activation.alerts.social-media.metrics.share-of-posts.title")}
                automationId="share-of-posts-metrics-widget"
                seeAllAutomationId="see-all-share-of-posts-button"
            >
                <MetricWidgetChart>
                    <ShareMetricLegend
                        dataAutomation="share-of-posts-metrics-legend"
                        shareDataAutomation="share-of-posts-legend-share"
                    />
                </MetricWidgetChart>
            </MetricWidgetContainer>
            <MetricWidgetModal
                title={translate("activation.alerts.social-media.metrics.share-of-posts.title")}
                automationId="all-share-of-posts-modal"
            >
                <ShareMetricTable />
            </MetricWidgetModal>
        </MetricWidgetProvider>
    );
};
